module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"no":{"title":"Fortsett"},"en":{"title":"In progress"}}')
  delete Component.options._Ctor
}
